import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { getLibraryPageTokens } from '../getLibraryPageTokens';
import { LIBRARY_PAGE_LAYOUT_SIZES } from '../libraryTokens';

export interface LibraryPageHeaderProps {
  subtitle: string;
  title?: string;
}

export function LibraryPageHeader({
  subtitle,
  title = 'Library',
}: LibraryPageHeaderProps): JSX.Element {
  const theme = useTheme();
  const tokens = getLibraryPageTokens(theme);

  return (
    <>
      <Typography
        component="h2"
        sx={{
          fontSize: '30px',
          fontWeight: 500,
          lineHeight: '36px',
          letterSpacing: '0.3955px',
          color: tokens.pageHeadingColor,
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          mt: `${LIBRARY_PAGE_LAYOUT_SIZES.sectionTitleGap}px`,
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: '24px',
          letterSpacing: '-0.3125px',
          color: tokens.pageSubtitleColor,
        }}
      >
        {subtitle}
      </Typography>
    </>
  );
}
